// src/assets/js/tokenService.js
const TOKEN_KEY = 'access_token';
const USER_KEY = 'current_user';

export function setAuth(payload) {
  // payload 为后端登录返回的对象
  // {
  //   success: true,
  //   userId,
  //   username,
  //   roles,
  //   state,
  //   access_token,
  //   token_type,
  //   issued_at,
  //   expires_in
  // }
  if (!payload || !payload.access_token) return;
  window.localStorage.setItem(TOKEN_KEY, payload.access_token);
  window.localStorage.setItem(
    USER_KEY,
    JSON.stringify({
      userId: payload.userId,
      username: payload.username,
      roles: payload.roles,
      state: payload.state,
      issued_at: payload.issued_at,
      expires_in: payload.expires_in
    })
  );
}

export function getToken() {
  return window.localStorage.getItem(TOKEN_KEY) || '';
}

export function getUser() {
  const v = window.localStorage.getItem(USER_KEY);
  return v ? JSON.parse(v) : null;
}

export function clearAuth() {
  window.localStorage.removeItem(TOKEN_KEY);
  window.localStorage.removeItem(USER_KEY);
}

export function isSignedIn() {
  return !!getToken();
}
